module.exports = __webpack_public_path__ + "img/band-1.01f31e0d.png";